import React, { Component } from 'react'
import cx from 'classnames'
import values from 'lodash/values'
import PropTypes from 'prop-types'
import { Icon as ManyUIIcon } from '@manychat/manyui'

import { NextStepTypeColors } from 'common/builder/models/Source/constants'
import { Col, Row } from 'components/Grid'
import Label from 'components/Label'

import cm from './NextStepSelectItem.module.css'

export default class NextStepSelectItem extends Component {
  static propTypes = {
    onSelect: PropTypes.func.isRequired,
    title: PropTypes.string,
    type: PropTypes.string,
    icon: PropTypes.string,
    color: PropTypes.oneOf(values(NextStepTypeColors)),
    proBadge: PropTypes.bool,
    disabled: PropTypes.bool,
    tooltip: PropTypes.string,
  }

  render() {
    const { title, icon, color, onSelect, proBadge, tooltip, disabled } = this.props
    const className = cx(cm.option, 'm-b-xs', {
      [cm.disabled]: disabled,
    })

    const testId = this.props['data-test-id']
      ? `next-step-select-${this.props['data-test-id']}`
      : `next-step-select-${icon}`

    const onClick = () => {
      onSelect()
    }

    return (
      <Row
        data-test-id={testId}
        data-onboarding-id={testId}
        middle
        onClick={disabled ? () => {} : onClick}
        className={className}
        data-title={tooltip ? tooltip : null}
      >
        <Col width={60}>
          <div className="text-center d-flex justify-center">
            {React.createElement(ManyUIIcon[icon], {
              color: color,
              size: 32,
            })}
          </div>
        </Col>
        <Col>
          <div className="text-subheading">
            <span>{title}</span>
            {Boolean(proBadge) && <Label className={cx(cm.proLabel, 'm-l-xs')}>PRO</Label>}
          </div>
        </Col>
      </Row>
    )
  }
}
